import "../CsplImage/CsplImage.css";

// img url - the image base 64 or the url
// onClick - function to be called on image click

function CsplImage(props) {

  // function to be called on image click
  function onImageClick(event){
    event.stopPropagation();
    if(props.onClick){
      props.onClick();
    }

  }

  // show pointer for cursor only if there is a function on click
  function imageContentClass(){
    
    let pointerClass = "cursor_pointer";

    let imageContentClass = "cspl-card-top-content";

    if(props.onClick){
      imageContentClass = `${imageContentClass} ${pointerClass}`
    }
    return imageContentClass;
    
  }

  return (
    <div className="cspl-card-border" onClick={(event) => onImageClick(event)}>
      <div className={imageContentClass()}>
        <p>
          <img src={props.imgUrl} className="cspl-card-image" />
        </p>
      </div>
    </div>
  );
}
export default CsplImage;
